import React, { Component } from 'react';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import { MenuItem } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import { Container } from "react-bootstrap";


class Footer extends Component {

    render() {
        return (
            <BottomNavigation class="footer-bar">

                <div className="footer">
                <Container className="tab-bar">

                <MenuItem>
                        <NavLink className="tab" to="/imprint">Imprint</NavLink>
                    </MenuItem>
                    </Container>

                </div>

            </BottomNavigation >
        )
    }
}

export default Footer;